var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"container-fluid pb-10"},[_c('h1',{staticClass:"main-title mb-8"},[_vm._v(_vm._s(_vm.$t("mainNav.productionDataExport")))]),(!_vm.isPresenter)?_c('production-data-export-menu'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }